<!--~
~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
~ to an End-User License Agreement included in a separate file named EULA.txt
~ that is distributed with this file.
-->
<form name="bufferForm" #bufferForm="ngForm"
      (ngSubmit)="createBuffer(bufferDistance, selectWithin)">
    <h3 mat-dialog-title>Create Buffer</h3>
    <div mat-dialog-content>
        <div fxLayout="column" fxLayoutGap="12px">
          <div fxLayout="row" fxLayoutGap="4px" fxLayoutAlign="space-between center">
            @for (range of bufferRanges; track range) {
              <div>
                <button mat-raised-button type="button"
                (click)="createBuffer(range, selectWithin)">{{ range }} ft</button>
              </div>
            }
          </div>
          <mat-form-field>
            <input matInput
              name="bufferDistance"
              pattern="[0-9]+"
              placeholder="Buffer Distance"
              required
              [(ngModel)]="bufferDistance" cdkFocusInitial />
          </mat-form-field>
          <mat-checkbox name="selectWithin"
          [(ngModel)]="selectWithin">Select</mat-checkbox>
        </div>
    </div>
    <div mat-dialog-actions fxLayout="row" fxLayoutAlign="end center">
      <button mat-button (click)="onCancel()">Cancel</button>
      <button mat-button type="submit"
      [disabled]="bufferForm.value=='' || !bufferForm.valid">Create Buffer</button>
    </div>
</form>
